import type { FC } from 'react';

import Button from '@helsenorge/designsystem-react/components/Button';
import Spacer from '@helsenorge/designsystem-react/components/Spacer';

import { isAuthorized } from '@helsenorge/framework-utils/hn-authorize';

interface Props {
  innsynslenke: string;
  innsynslenkeLabel: string;
  innsynslenkeLoggInnLabel: string;
}

export const InnsynsLinkButton: FC<Props> = ({ innsynslenke, innsynslenkeLabel, innsynslenkeLoggInnLabel }) => {
  return (
    <>
      <Spacer size="l" />
      <Button htmlMarkup="a" href={`/${innsynslenke}`}>
        {isAuthorized() ? innsynslenkeLabel : innsynslenkeLoggInnLabel}
      </Button>
    </>
  );
};
